import { Area, AreaChart, ResponsiveContainer } from "recharts";

interface IProps {
  data: { value: number }[];
  stopColor: string;
  stroke: string;
  id: string;
  hide?: boolean;
}

const SiteAreaChart: React.FC<IProps> = ({
  data,
  stopColor,
  stroke,
  id,
  hide,
}) => {
  return (
    <ResponsiveContainer width="100%" height={40}>
      <AreaChart data={data} margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
        <defs>
          <linearGradient id={id}>
            <stop stopColor={stopColor} stopOpacity={1} />
          </linearGradient>
        </defs>
        <Area
          type="linear"
          dataKey="value"
          stroke={stroke}
          strokeWidth={1}
          fill={`url(#${id})`}
          isAnimationActive={true}
          animationDuration={1500}
          animationEasing="linear"
          hide={hide}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default SiteAreaChart;
